import React from 'react';
import PropTypes from 'prop-types';

const IconPositiveFeedback = ({ width = 16, height = 16 }) =>
    <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox='0 0 16 16' fill='none'>
        <path d='M9.69366 6.73668H13.3823C15.0797 6.73668 12.873 14 11.657 14H3.30966C3.14074 14.0014 2.97817 13.9357 2.85766 13.8174C2.73716 13.699 2.66858 13.5376 2.66699 13.3687V7.11201C2.66699 6.88068 2.79566 6.66801 3.00166 6.55734C4.37633 5.82001 5.98899 5.21601 6.78699 3.80468L7.64033 2.29401C7.6912 2.20425 7.76509 2.12969 7.85439 2.07801C7.94369 2.02633 8.04515 1.9994 8.14833 2.00001C10.2683 2.00001 9.63966 5.08668 9.35166 6.31334C9.34007 6.36442 9.34021 6.41745 9.35206 6.46847C9.36391 6.51948 9.38716 6.56715 9.42007 6.60789C9.45299 6.64862 9.4947 6.68138 9.54208 6.70368C9.58947 6.72599 9.64129 6.73727 9.69366 6.73668Z' stroke='black' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
    ;

IconPositiveFeedback.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export default IconPositiveFeedback;
